import { array, boolean, object, string, TypeOf } from 'zod';

/* -------------------------------- Category -------------------------------- */

export const Category = object({
    id: string(),
    categoryTypeId: string(),
    name: string(),
});

export type Category = TypeOf<typeof Category>;

/* ------------------------------ AllCategories ----------------------------- */

export const AllCategories = object({
    data: array(Category),
});

export type AllCategories = TypeOf<typeof AllCategories>;

/* ------------------------------ CategoryType ------------------------------ */

export const CategoryType = object({
    id: string(),
    name: string(),
    exclusive: boolean(),
});

export type CategoryType = TypeOf<typeof CategoryType>;

/* ---------------------------- AllCategoryTypes ---------------------------- */

export const AllCategoryTypes = object({
    data: array(CategoryType),
});

export type AllCategoryTypes = TypeOf<typeof AllCategoryTypes>;
